export class HierarchyA {
  hoId: number;
  level: number;
  levelUpdated: boolean;
  type: string;
}

